/* global ieversion ga dataLayer */
import React from 'react';
import formatDate from 'date-fns/format';
import parseDate from 'date-fns/parse';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import store from 'store';
import storageEngine from 'store/src/store-engine';
import sessionstore from 'store/storages/sessionStorage';
import _get from "lodash/get";
import _isUndefined from "lodash/isUndefined";
import {getLangCode, stringBundle} from '../stringBundle';

const sessionStorage = storageEngine.createStore([sessionstore], []);

export default class utils {

  static getDateReportGeneratedFormatted(provider) {
    const reportGenerated = _get(provider, 'summary.reportGenerated', '');
    const reportGeneratedDate = reportGenerated ? new Date(reportGenerated) : '';
    return reportGenerated ? `${reportGeneratedDate.getUTCMonth() + 1}/${reportGeneratedDate.getUTCDate()}/${reportGeneratedDate.getUTCFullYear()}` : '';
  }

  static clearSessionAndCookies() {
    store.clearAll();
    sessionStorage.clearAll();
    let cookies = document.cookie;
    for (let i = 0; i < cookies.split(";").length; ++i) {
      let myCookie = cookies[i];
      let pos = myCookie.indexOf("=");
      let name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }

  static getCookieValue(cookie, name) {
    let nameStr = name + "=";
    let decodedCookie = decodeURIComponent(cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(nameStr) === 0) {
        return c.substring(nameStr.length, c.length);
      }
    }
    return "";
  }

  static log(parameters) {
    let url = this.getLogPath();

    let selectedParameters = {
      source: _get(parameters, 'source', 'portal'),
      version: _get(parameters, 'version', ''),
      feature: _get(parameters, 'feature', ''),
      actionType: _get(parameters, 'actionType', ''),
      message: _get(parameters, 'message', ''),
      accountId: _get(parameters, 'accountId', ''),
      token: _get(parameters, 'token', ''),
      startTime: _get(parameters, 'startTime', ''),
      endTime: _get(parameters, 'endTime', ''),
      elapsedTime: _get(parameters, 'elapsedTime', ''),
      error: _get(parameters, 'error', ''),
    };

    const config = {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCookieValue(document.cookie, 'XSRF-TOKEN')
      },
      credentials: 'include',
      body: JSON.stringify(selectedParameters)
    };
    return fetch(url, config)
  }

  static convertEpochGMTtoMST(epochtimeGMT) {
    let millisecondsFromGMT = 25200000;
    let epochtimeMST = epochtimeGMT ? epochtimeGMT - millisecondsFromGMT : '';
    return epochtimeMST;
  }

  static mapComparedObjectKeys(a, b) {
    let objectKeyList = [];
    let comparedObjectsList = this.compareAlertDetailObjects(a, b);

    comparedObjectsList.forEach((t) => {
      objectKeyList[t.key] = t
    });

    return objectKeyList;

  }

  static compareAlertDetailObjects(a, b) {

    // This method helps to compare object A and B.
    // The final comparison result will be placed in an array of objects called final

    let final = [];

    let finalKeys = [];

    // Pickup all the unique keys from object A
    Object.keys(a).forEach((key) => {
      if (finalKeys.indexOf(key) === -1) {
        finalKeys.push(key);
      }
    });

    // Pickup all the unique keys from object B
    Object.keys(b).forEach((key) => {
      if (finalKeys.indexOf(key) === -1) {
        finalKeys.push(key);
      }
    });


    // Loop through the complete list of finalKeys

    finalKeys.forEach((key) => {

      // We ignore the alertEntry and Narratives

      if (key !== 'alertEntry' && key !== "narratives") {

        if (a.hasOwnProperty(key)) {

          if (b.hasOwnProperty(key)) {

            // The property exists in both A and B

            if (typeof a[key] === 'object') {

              // Case when the specific property value exists in both A & B and is an object
              // Quick comparison of the stringified elements can let us know if the children objects are different

              let status = JSON.stringify(a[key]) === JSON.stringify(b[key]) ? 'same' : 'changed';

              if (status === 'changed') {

                // Value of A object differs from B object

                final.push({
                  key,
                  type: 'object',
                  status,
                  value: b[key].description ? b[key].description : b[key].value ? b[key].value : b[key].amount ? b[key].amount : '',
                  before: a[key].description ? a[key].description : a[key].value ? a[key].value : a[key].amount ? a[key].amount : '',
                });

              }
              else {
                // Value of A object is the same as B object
                final.push({
                  key,
                  type: 'object',
                  status,
                  value: b[key].description ? b[key].description : b[key].value ? b[key].value : b[key].amount ? b[key].amount : '',
                });

              }

            }
            else if (b[key] !== a[key]) {
              // Value of A string differs from B string
              final.push({
                key,
                type: 'string',
                status: 'changed',
                value: b[key],
                before: a[key]
              });

            }
            else {
              // A value is the same as B string
              final.push({key, type: 'string', status: 'same', value: a[key]});
            }

          }
          else {
            // Value of A string no longer exists in B
            final.push({key, type: 'string', status: 'removed', value: null, before: a[key]});

          }

        } // Only B have this property
        else if (b.hasOwnProperty(key) && b[key]) {
          if (typeof b[key] === 'object') {
            if (b[key].description) {
              // B value is new description object
              final.push({
                key,
                type: 'object',
                status: 'added',
                value: b[key].description,
                before: null
              });
            }
            else if (b[key].amount) {
              // B value is new dollar object
              final.push({
                key,
                type: 'object',
                status: 'added',
                value: b[key].amount,
                before: null,
                currency: b[key].currency
              });
            }
          }
          else {
            // B value is new string
            final.push({key, type: 'string', status: 'added', value: b[key], before: null});
          }
        }
        else {
          // Both values are null
          final.push({key, type: 'string', status: 'same', value: null, before: null});
        }
      }

    })

    return final;

  }

  static someObjectParametersHaveValue(obj) {

    let notEmpty = false;

    if (obj) {

      let allKeys = Object.keys(obj);

      if (allKeys) {

        allKeys.forEach((key) => {

          if (obj[key].value) {
            notEmpty = true;
          }

        });

      }

    }

    return notEmpty;
  }

  static formatDateShortenedMonth(date) {
    if (date) {
      const newDate = date ? new Date(date) : Date.now();
      const utcDate = new Date(
        newDate.getUTCFullYear(),
        newDate.getUTCMonth(),
        newDate.getUTCDate(),
        newDate.getUTCHours(),
        newDate.getUTCMinutes(),
        newDate.getUTCSeconds()
      );

      return formatDate(utcDate, 'MMM D, YYYY')
    }
    return null
  }

  static showLastDigitsOnly(val, digitsToNotShow = 4) {

    if (val && val.length > 0) {
      let vis = val.slice(-1 * digitsToNotShow);
      let countNum = '';

      for (let i = (val.length) - digitsToNotShow; i > 0; i--) {
        countNum += '*';
      }

      return countNum + vis
    }
    return null


  }

  static formatMoney(n, c, d, t) {
    let ca = isNaN(Math.abs(c)) ? 2 : Math.abs(c);
    let da = d === undefined ? "." : d;
    let ta = t === undefined ? "," : t;
    let s = n < 0 ? "-" : "";
    let un = +n;
    let p = Math.abs(un || 0).toFixed(ca);
    let i = `${parseInt(p, 10)}`;
    let j = i.length > 3 ? i.length % 3 : 0;

    if (!un) {
      return false;
    }
    return s + (j ? i.substr(0, j) + ta : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${ta}`) + (ca ? da + Math.abs(un - i).toFixed(ca).slice(2) : "");
  }

  static showAsDollar(num) {
    if (num && num.amount >= 0) {
      return `$${this.formatMoney(parseFloat(num.amount).toFixed(2))}`
    }
    return num ? `$${this.formatMoney(parseFloat(num).toFixed(2))}` : ''

  }

  static convertToCurrencyFormatted(currencyInput, maxDecimals) {

    const localizer = {
      'USD': 'en-US',
      'GBP': 'en-GB',
      'AUD': 'en-AU',
      'INR': 'en-IN',
      'CNY': 'zh-CN'
    };

    maxDecimals = maxDecimals || 0;
    let currencyType = _get(currencyInput, 'currency', 'USD');
    let currencyValue = _get(currencyInput, 'amount');

    if (_isUndefined(currencyValue)) {
      return '-'
    }

    if (typeof currencyInput === 'string') {
      currencyValue = currencyInput || 0;
    }
    const locale = localizer[currencyType];

    const numberFormat = new Intl.NumberFormat([locale], {
      style: "currency",
      currency: currencyType,
      currencyDisplay: "symbol",
      minimumFractionDigits: maxDecimals,
      maximumFractionDigits: maxDecimals
    });

    return numberFormat.format(currencyValue)
  }

  static phoneNumberFormat(phonenumber) {

    let phonenumberFormatted = ""
    let s2;
    let m;

    if (phonenumber) {
      if (phonenumber.length === 11) {
        s2 = (`${phonenumber}`).replace(/\D/g, '');
        m = s2.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
        phonenumberFormatted = (!m) ? null : `${m[1]}(${m[2]}) ${m[3]}-${m[4]}`;
      }
      else if (phonenumber.length === 10) {
        s2 = (`${phonenumber}`).replace(/\D/g, '');
        m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        phonenumberFormatted = (!m) ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
      }
      else if (phonenumber.length === 7) {
        s2 = (`${phonenumber}`).replace(/\D/g, '');
        m = s2.match(/^(\d{3})(\d{4})$/);
        phonenumberFormatted = (!m) ? null : `${m[1]}-${m[2]}`;

      }
      else {
        phonenumberFormatted = phonenumber
      }
      return phonenumberFormatted
    }
    return null
  }


  static postalCodeFormat(postalcode) {

    if (postalcode) {

      let a = postalcode.split("");

      return (a.length > 5) ? `${a.slice(0, 5).join("")}-${a.slice(5, a.length).join("")}` : a.join("")

    }
    return null

  }

  static dateEasyFormatted(timestamp) {

    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    let pastDate;
    let currentDate = (new Date()).getTime();

    if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      let timestamp2 = new Date(timestamp);
      let timestamp2Epochtime = timestamp2.getTime();
      pastDate = new Date(timestamp2Epochtime);
    }
    else if (typeof timestamp === 'object') {
      pastDate = timestamp;
    }

    let seconds = (currentDate - pastDate) / 1000;
    let hours = Math.round((seconds / 60) / 60);
    let days = Math.round(((seconds / 60) / 60) / 24);
    let currentYear = new Date().getUTCFullYear();

    let displayDay = pastDate ? pastDate.getUTCDate() : '';
    let displayMonth = pastDate ? parseInt(pastDate.getUTCMonth(), 10) + 1 : '';
    let displayMonthText = pastDate ? months[displayMonth - 1] : '';
    let displayYear = pastDate ? pastDate.getUTCFullYear() : '';

    if (hours < 24) {
      return 'Today';
    }
    else if (days === 1) {
      return 'Yesterday';
    }
    else if (currentYear === displayYear) {
      return `${displayMonthText} ${displayDay}`;
    }
    return `${displayMonthText} ${displayDay}, ${displayYear}`;

  }

  static convertEpochToDate(epoch) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', ' Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const epochVal = epoch || ''; //handle null values
    const date = new Date(epochVal);
    const day = date ? date.getUTCDate() : '';
    const month = date ? months[date.getUTCMonth()] : '';
    const year = date ? date.getUTCFullYear() : '';
    const formattedDate = month && day && year ? `${month} ${day}, ${year}` : '-';
    return formattedDate;
  }

  static convertEpochToDateNormal(epoch) {
    const epochVal = epoch || ''; //handle null values
    const date = new Date(epochVal);
    const day = date ? date.getUTCDate() : '';
    const month = date ? date.getUTCMonth() + 1 : '';
    const year = date ? date.getUTCFullYear() : '';
    const formattedDate = month && day && year ? `${month}/${day}/${year}` : '-';
    return formattedDate;
  }

  static historyToObject(dates, scores) {
    // Check length
    if (Array.isArray(dates) && Array.isArray(scores)) {
      const datesArr = dates;
      const scoresArr = scores;
      const historyObject = {
        dates: datesArr,
        scores: scoresArr,
      };
      return historyObject;
    }
  }


  static convertUpperCase(str) {
    let description = str.toLowerCase();
    description = description.split(' ');
    for (let i = 0; i < description.length; i++) {
      if (i === 0) {
        description[i] = description[i]
          .charAt(0)
          .toUpperCase() + description[i]
          .slice(1);
      }
    }
    return description.join(' ');
  }

  static translateProvider(translate) {
    let provider = null;
    switch (translate) {
      case 'EFX':
        provider = 'Equifax';
        break;
      case 'EXP':
        provider = 'Experian';
        break;
      case 'TU':
        provider = 'TransUnion';
        break;
      default:
        provider = '';
        break;
    }
    return provider;
  }

  static convertMonthsToYearsMonths(months) {
    const monthsPart = months % 12;
    const yearsPart = (months - monthsPart) / 12;
    let monthPartString = '';
    let yearsPartString = '';

    if (monthsPart > 0) {
      monthPartString = `${monthsPart} Month(s)`;
    }
    if (yearsPart > 0) {
      yearsPartString = `${yearsPart} Year(s)`;
    }
    return (
      <span>
				{yearsPartString} {monthPartString}
			</span>
    );
  }

  static convertSecondsToYearsMonths(d1, d2) {
    const seconds = (d1 - d2) / 1000;
    const secondsInYear = 31556926;
    const secondsInMonth = 2629743;
    const monthsSeconds = seconds % secondsInYear;
    const monthsPart = Math.floor(monthsSeconds / secondsInMonth);
    const yearsPart = Math.floor(seconds / secondsInYear);
    let monthPartString = '';
    let yearsPartString = '';
    if (monthsPart > 0) {
      monthPartString = `${monthsPart} Month(s)`;
    }
    if (yearsPart > 0) {
      yearsPartString = `${yearsPart} Year(s)`;
    }
    return (
      <span> {yearsPartString} {monthPartString} </span>
    );
  }

  static formatPhone(num) {
    if (num && num.length === 10) {
      return num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return num;
  }

  /**
   * Get startDate in required format based on the number of days passed.
   *
   * @param {number} days Number of days to go back in past.
   * @return {string} startDate Format is YYYY-MM-DD.
   */
  static getStartDate(days) {
    let d = new Date();
    d.setDate((d.getDate() - days) + 1);
    let startDate = d.getDate();
    startDate = startDate > 9 ? startDate : `0${startDate}`;
    let startMonth = d.getMonth() + 1;
    startMonth = startMonth > 9 ? startMonth : `0${startMonth}`;
    let startYear = d.getFullYear();
    let dStart = `${startYear}-${startMonth}-${startDate}`;
    return dStart;
  }

  /**
   * Returns the endDate, essentially, today's date.
   *
   * @return {string} endDate Format is YYYY-MM-DD.
   */
  static getEndDate() {
    let d = new Date();
    let endDate = d.getDate();
    endDate = endDate > 9 ? endDate : `0${endDate}`;
    let endMonth = d.getMonth() + 1;
    endMonth = endMonth > 9 ? endMonth : `0${endMonth}`;
    let endYear = d.getFullYear();
    let dEnd = `${endYear}-${endMonth}-${endDate}`;

    return dEnd;
  }

  /**
   * Returns the amount in format of comma separated value.
   * Example: 21367 turns into 21,367.
   *
   * @param amount
   * @return amt
   */
  static convertAmountToString(amount) {
    let amt = Number(amount).toFixed(2);
    return amt;
  }

  /**
   * Converts the YYYY-MM-DD format to something like Sep 25, 2010
   *
   * @param date
   * @return date
   */
  static convertDateToString(date) {
    let formattedDate = "";

    if (date) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', ' Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      let dateArr = date.split("-");
      let month = months[parseInt(dateArr[1], 10) - 1];
      let dd = dateArr[2];
      let yyyy = dateArr[0];

      formattedDate = `${month} ${dd}, ${yyyy}`;
    }

    return formattedDate;
  }

  /**
   * Converts the YYYY-MM-DD format to MM/DD/YYYY
   *
   * @param date
   * @return {*}
   */
  static convertDateToSlashFormat(date) {
    let formattedDate = "";

    if (date) {
      let dateArr = date.split("-");
      let mm = dateArr[1];
      let dd = dateArr[2];
      let yyyy = dateArr[0];

      formattedDate = `${mm}/${dd}/${yyyy}`;
    }

    return formattedDate;
  }

  /**
   * The date library we're using in a couple classes, date-fns, has browser support issues for Firefox and possibly IE.
   * It parses MM-DD-YYYY dates on Chrome but not those browsers.
   * This is a workaround since we don't want to adopt a larger date library like moment.
   * @param dateString
   */
  static parseMMdashDDdashYYYY(dateString) {
    let nums = dateString.split('-');
    return parseDate(nums[2] + '-' + nums[0] + '-' + nums[1]);
  }

  /**
   * Returns an object with count of transactions and total amount for given startDate and list of transactions.
   *
   * @param startDate
   * @param data
   * @return {{count: number, total: (*|amt)}}
   */
  static numberOfTransactions(startDate, data) {
    let transactions = data;
    let count = 0;
    let total = 0;

    if (Array.isArray(transactions) && !_isEmpty(transactions)) {
      transactions.forEach((arrayItem) => {
        if (arrayItem.postedDate >= startDate) {
          count += 1;
          if (!_isEmpty(arrayItem.absoluteAmount)) {
            total += parseFloat(arrayItem.absoluteAmount);
          }
        }
      });
    }
    else if (transactions.postedDate >= startDate) {
      count = 1;
      total = parseFloat(transactions.amount);
    }
    return {count, total: utils.convertAmountToString(total)};
  }

  static numberWithCommas(number) {
    return number ? number.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0';
  }

  static getFormattedDates(date) {
    const date1 = new Date(date || '');
    let day = date1 ? date1.getUTCDate() : '';
    let month = date1 ? parseInt(date1.getUTCMonth(), 10) + 1 : '';
    const year = date1 ? date1.getUTCFullYear() : '';
    return month && day && year ? `${month}/${day}/${year}` : undefined;
  }

  static browserIsMobile() {
    let check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
    }(navigator.userAgent || navigator.vendor || window.opera));
    return check;
  }

  static getCurrentBrowser() {
    let ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {name: 'MSIE', version: (tem[1] || '')};
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem && tem.length > 0 && tem[1] === 'Edge') {
        return {name: 'Edge', version: tem[2]}
      }
      if (tem != null) {
        return {name: 'Opera', version: tem[2]};
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem != null) M.splice(1, 1, tem[1]);

    if (M[0] && M[1]) {
      return {name: M[0], version: M[1]};
    }

    /*if (navigator && navigator.userAgent && navigator.userAgent.indexOf('MSIE') != -1) {
     let detectIEregexp = /MSIE (\d+\.\d+);/ //test for MSIE x.x
     }
     else { // if no "MSIE" string in userAgent
     let detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ //test for rv:x.x or rv x.x where Trident string exists
     }*/

    let finalVersion = {};
    switch (true) {
      case (ieversion >= 12):
        finalVersion = {name: 'MSIE', version: '12'}
        break;
      case (ieversion >= 11):
        finalVersion = {name: 'MSIE', version: '11'}
        break;
      case (ieversion >= 10):
        finalVersion = {name: 'MSIE', version: '10'}
        break;
      case (ieversion >= 9):
        finalVersion = {name: 'MSIE', version: '9'}
        break;
      case (ieversion >= 8):
        finalVersion = {name: 'MSIE', version: '8'}
        break;
      case (ieversion >= 7):
        finalVersion = {name: 'MSIE', version: '7'}
        break;
      case (ieversion >= 6):
        finalVersion = {name: 'MSIE', version: '6'}
        break;
      case (ieversion >= 5):
        finalVersion = {name: 'MSIE', version: '5'}
        break;
      default:
        break;
    }
    return finalVersion;

  }

  static browserIsInvalid(currentbrowser) {
    if (this.browserIsMobile()) {
      return false;
    }

    let minValidBrowser = {
      Chrome: 20,
      Firefox: 18,
      Safari: 6,
      MSIE: 10,
      Edge: 13
    };

    // return ( currentbrowser.version >= minValidBrowser[currentbrowser.name] ) ? false : true;
    return (currentbrowser.version < minValidBrowser[currentbrowser.name]);
  }

  static trackEvent(option) {
    if (typeof dataLayer !== "undefined") {
      dataLayer.push({
        'eventCategory': _get(option, 'category', ''),
        'eventAction': _get(option, 'action', ''),
        'eventLabel': _get(option, 'label', ''),
        'eventValue': _get(option, 'value', ''),
        'eventNonInteraction': _get(option, 'nonInteraction', ''),
        'event': _get(option, 'event') || 'trackEvent'
      });
    }
  }

  /**
   * Sets Analytics userId.
   * @param userId
   */
  static setAnalyticsSession(userId) {
    if (ga && !_isEmpty(userId)) {
      ga('set', 'userId', userId);
    }
  }

  static trackEventForManageAccount(inputType, action, hasValue) {
    const labelMap = {
      ADDRESS: 'Address',
      PHONE_NUMBER: 'Phone',
      PHONE: 'Phone',
      E_MAIL_ADDR: 'Email',
      EMAIL: 'Email',
      DRIVERS_LICENSE: 'Driver License',
      INSURANCE_CARD: 'Insurance',
      transaction: 'TXM_Purchase',
      transfer: 'TXM_Transfer',
      withdrawal: 'TXM_Cash',
      USERNAME: 'Username',
      PASSWORD: 'Password',
      VERBAL_PASSCODE: 'Verbal_Passcode',
      BANK_ACCOUNT: 'Internet_Monitor',
      CREDIT_DEBIT: 'Internet_Monitor'
    };
    let option = {
      category: "MAccount",
      action,
      label: labelMap[inputType] ? labelMap[inputType] : inputType,
      event: 'trackEvent'
    };
    if (hasValue) {
      option.value = 1;
    }
    this.trackEvent(option);
  }

  static getBankInfoByInstitutionId(institutionId) {
    const InstitutionIdMap = {
      "643": {
        index1: 0,
        index2: 0,
        label: 'Chase',
        altText: "Chase Bank"
      },
      "2852": {
        index1: 1,
        index2: 1,
        label: 'BOA',
        altText: "Bank of America"
      },
      "5": {
        index1: 2,
        index2: 17,
        label: 'Wells',
        altText: "Wells Fargo"
      },
      "1503": {
        index1: 3,
        index2: 2,
        label: 'Citi',
        altText: "Citibank"
      },
      "524": {
        index1: 4,
        index2: 3,
        label: 'US',
        altText: "U.S. Bank"
      },
      "1649": {
        index1: 5,
        index2: 4,
        label: 'MS',
        altText: "Morgan Stanley"
      },
      "2162": {
        index1: 6,
        index2: 5,
        label: 'PNC',
        altText: "PNC"
      },
      "4132": {
        index1: 10,
        index2: 9,
        label: 'TD',
        altText: "TD Bank"
      },
      "3612": {
        index1: 8,
        index2: 7,
        label: 'HSBC',
        altText: "HSBC Bank"
      },
      "16441": {
        index1: 17,
        index2: 14,
        altText: "RBC"
      },
      "16486": {
        index1: 18,
        index2: 15,
        altText: "Citizens Bank"
      },
      "8995": {
        index1: 19,
        index2: 16,
        altText: "USAA"
      },
      "2856": {
        index1: 7,
        index2: 6,
        label: 'CapOne',
        altText: "Capital One"
      }
    };

    if (InstitutionIdMap[institutionId] !== (null || undefined)) {
      return {
        logo: `bank-logo-${InstitutionIdMap[institutionId].index1 + 1}`,
        linearLogo: `bank-linear-logo-${InstitutionIdMap[institutionId].index2 + 1}`,
        label: InstitutionIdMap[institutionId].label,
        altText: InstitutionIdMap[institutionId].altText
      }
    }

    return {
      logo: null,
      linearLogo: null,
      label: '',
      altText: ''
    }

  }

  static redactNotes(notes) {
    let patternCreditCard = /\d{3,}\s{0,}?-?\d{3,}\s{0,}?-?\d{3,}\s{0,}?-?\d{2,}/ig;
    let patternCVV = /cvv:?\s{1,}?(which is|is|which was|was)?\s{1,}?[0-9]{3}/ig;
    let patternSSN = /([^0-9-]|^)([0-9]{3}-[0-9]{2}-[0-9]{4})([^0-9-]|$)/ig;
    let patternDriverLicense = /(driver)?('s)?(\s{0,})(license)(\.)?(\s{0,})?(number)?\s{0,}?(\W(which is)|\W(that is)|of|is)?\s{0,}([^(&||\s)]{5,10})/ig;
    let patternDOB = /(dob|birthday|birth date|birthdate|date of birth|birth day)\s{0,}(that|which)?\s{0,}(starts|started)?\s{0,}(was|is)?\s{0,}(on|of)?\s{0,}(\d{1,2}|(Jan(uary)?|Feb(ruary)?|Ma(r(ch)?|y))|Apr(il)?|Ju((ly?)|(ne?))|Aug(ust)?|Oct(ober)?|(Sep(?=\b|t)t?|Nov|Dec)(ember)?)(,|\s|\.|-|\/)(\d{1,2}|(Jan(uary)?|Feb(ruary)?|Ma(r(ch)?|y))|Apr(il)?|Ju((ly?)|(ne?))|Aug(ust)?|Oct(ober)?|(Sep(?=\b|t)t?|Nov|Dec)(ember)?)(,|\s|\.|-|\/)(\s)?(\d{2,4})/ig;

    return notes
      .replace(patternDOB, " BIRTHDAY: **/**/****")
      .replace(patternSSN, " ***-**-****")
      .replace(patternCreditCard, " ****-****-****-****")
      .replace(patternDriverLicense, " DRIVER'S LICENSE NUMBER: *******")
      .replace(patternCVV, " CVV: ***");
  }

  static formatFullDate(date) {
    let result = null;
    let dateFormat1 = date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let dateFormat2 = date.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    if (dateFormat1) {
      let dateDigits = date.split('-');
      result = `${dateDigits[1]}/${dateDigits[2]}/${dateDigits[0]}`;
    }
    if (dateFormat2) {
      let dateDigits = date.split('/');
      result = `${dateDigits[2]}-${dateDigits[0]}-${dateDigits[1]}`;
    }
    return result;
  }

  static getMaxRecordCount(data, inputType, defaultVal) {
    let maxCount = defaultVal;
    if (data !== undefined && data.zone !== undefined) {
      const zones = data.zone;
      const recordtype = _filter(zones, {recordType: inputType});
      maxCount = _get(recordtype[0], 'maxRecordCount', defaultVal);
    }
    return Number(maxCount);
  }

  static asc2Str(stringIncludingASCII) {
    if (_isEmpty(stringIncludingASCII)) return '';

    return stringIncludingASCII.replace(/&#([0-9]{2,3});/g, (ascii) => {
      return String.fromCharCode(parseInt(ascii.substring(2, ascii.length - 1), 10));
    });
  }

  static compareStringDate(strDate1, strDate2) {
    /*Usable format: mm/dd/yyyy, mm-dd-yyyy*/
    let result = null;
    let date1Format1 = strDate1.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let date1Format2 = strDate1.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    let date2Format1 = strDate2.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let date2Format2 = strDate2.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    if ((date1Format1 || date1Format2) && (date2Format1 || date2Format2)) {
      return `${strDate1.substring(6)}${strDate1.substring(0, 2)}${strDate1.substring(3, 5)}` - `${strDate2.substring(6)}${strDate2.substring(0, 2)}${strDate2.substring(3, 5)}`;
    }
    return result;
  }

  static isFutureDate(date) {
    let dateFormat1 = date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let dateFormat2 = date.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    if ((dateFormat1 || dateFormat2)) {
      let now = new Date();

      let monthInt = now.getMonth() + 1;
      let monthStr = monthInt > 9 ? `${monthInt}` : `0${monthInt}`;
      let dateInt = now.getDate();
      let dateStr = dateInt > 9 ? `${dateInt}` : `0${dateInt}`;

      let nowStr = `${now.getFullYear()}${monthStr}${dateStr}`
      let targetDateStr = `${date.substring(6)}${date.substring(0, 2)}${date.substring(3, 5)}`;

      return targetDateStr - nowStr > 0;
    }
    return false;
  }

  static isValidDateRange(date) {
    let dateFormat1 = date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let dateFormat2 = date.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    if ((dateFormat1 || dateFormat2)) {
      let year = date.substring(6);
      return year >= parseInt(1000, 10) && year <= parseInt(9999, 10);
    }
    return false;
  }

  static isValidDateDigit(date) {
    let dateFormat1 = date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g);
    let dateFormat2 = date.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g);
    if ((dateFormat1 || dateFormat2)) {
      let dateDigits = parseInt(date.substring(3, 5), 10);
      let monthDigits = parseInt(date.substring(0, 2), 10);
      let yearDigits = parseInt(date.substring(6), 10);
      switch (monthDigits) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          return dateDigits <= 31 && dateDigits > 0;
        case 4:
        case 6:
        case 9:
        case 11:
          return dateDigits <= 30 && dateDigits > 0;
        case 2:
          return this.isLeapYear(yearDigits) ?
            dateDigits <= 29 && dateDigits > 0 :
            dateDigits <= 28 && dateDigits > 0;
        default:
          return false;
      }
    }
    return false;
  }

  static isLeapYear(year) {
    return (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0));
  }

  static getParameterByName(name, url) {
    /* eslint-disable no-useless-escape */
    let updatedName = name.replace(/[\[\]]/g, "\\$&");
    /* eslint-disable no-useless-escape */
    let regex = new RegExp(`[?&]${updatedName}(=([^&#]*)|&|#|$)`);
    let results = regex.exec(url || window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  static setLocalStorage(key, val) {
    store.set(key, val);
  }

  static removeLocalStorage(key) {
    store.remove(key);
  }

  static getLocalStorage(key) {
    return store.get(key);
  }

  static clearLocalStorage() {
    store.clearAll();
  }

  static getSessionStorage(key) {
    return sessionStorage.get(key);
  }

  static setSessionStorage(key, val) {
    sessionStorage.set(key, val);
  }

  static removeSessionStorage(key) {
    sessionStorage.remove(key);
  }

  static clearSessionStorage() {
    sessionStorage.clearAll();
  }

  static numericTextInputOnly(evt) {
    let event = evt || window.event;
    event.persist();
    let key = event.keyCode || event.which;
    key = String.fromCharCode(key);
    let regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
  }

  /*eslint-disable no-bitwise*/
  static isValidLuhn(value) {
    let len = value.length;
    let mul = 0;
    let prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]];
    let sum = 0;
    while (len--) {
      sum += prodArr[mul][parseInt(value.charAt(len), 10)];
      mul ^= 1;
    }
    return sum % 10 === 0 && sum > 0;
  }

  /*eslint-enable no-bitwise*/
  static isValidOtherCard(value) {
    const ascMatch = /^0*1*2*3*4*5*6*7*8*9*$/i;
    const desMatch = /^9*8*7*6*5*4*3*2*1*0*$/i;
    const sameMatch = /^([0-9])\\1*$/i;
    return !(ascMatch.test(value)) && !(desMatch.test(value)) && !(sameMatch.test(value));
  }

  static updateVisaPattern(creditCardType) {
    let visa = creditCardType.getTypeInfo(creditCardType.types.VISA);

    visa.prefixPattern = /^4[0-9]{12}(?:[0-9]{3})?$/;
    visa.exactPattern = /^4[0-9]{12}(?:[0-9]{3})?$/;

    creditCardType.addCard(visa);
  }

  /**
   * Checks if the current user has Transactions available for him.
   *
   * @param currentUser
   * @returns {boolean}
   */
  static showTransactions(currentUser) {
    const productFeatures = _get(currentUser, 'plan.productFeatures', '');
    const featureStatus = _get(productFeatures, 'transactionMonitoring.featureStatus', '');
    const fulfillmentStatus = _get(productFeatures, 'transactionMonitoring.fulfillmentStatus', '');
    return featureStatus === 'AVAILABLE' && fulfillmentStatus === 'ENROLLED';
  }


  static getCdnPath(path) {
    return `${window.REACT_APP_CDN_HOST}${window.REACT_APP_ASSETS_CDN_PATH}${path}`;
  }

  /* TODO: delete commented paths after we're sure they're unnecessary
    static getTermsConditionsAcceptPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/terms/accept`
    }

    static getTermsConditionsRequiredPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/terms/status`
    }

    static getTermsConditionsPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/terms`
    }

    static getTermsConditionsBypassPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/terms/bypass`
    }

    static getPendingMembersPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/pendingMembers`
    }

    static getDeletePendingMemberPath(pendingMemberId) {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/pendingMembers/${pendingMemberId}`
    }

    static getRedirectToStorePath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/redirectToStoreBySsoToken`
    }

    static getRedirectToStoreChangePlanPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/redirectToStoreBySsoToken?redirectLocation=plan&destinationapp=webstorememberapp`
    }
  */
  static getRedirectToPrivacyResults() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_PRIVACY_RESULTS_PATH}`;
  }

  /*
    static getUserNameByContactIdPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_USER_NAME_BY_CONTACT_ID_PATH}`;
    }

    static getUpdateUserNameByContactIdPath() {
      //return `${window.REACT_APP_MEMBER_API_HOST}/v1/principal/updateUserNameByContactId`;
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/credentialdata/update-username`;
    }

    static confirmUsernameByContactIdPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/credentialdata/confirmUserNameByContactId`;
    }

    static getUpdatePasswordByContactIdPath() {
      //return `${window.REACT_APP_MEMBER_API_HOST}/v1/principal/updatePasswordByContactId`;
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/credentialdata/update-password`;
    }

    static getIsUsernameAvailablePath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/credentialdata/checkUserName`;
    }
  */
  static getSmsNumberPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_SMS_NUMBER_PATH}`;
  }

  static getCancelSmsActivationPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_CANCEL_SMS_ACTIVATION_PATH}`;
  }

  static getSendSmsPhoneVerificationCodePath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_SEND_SMS_PHONE_VERI_CODE_PATH}`;
  }

  static getIvrOptInPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_IVR_OPT_IN_PATH}`;
  }

  static getIsSmsBlackListedPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_SMS_BLACKLISTED_PATH}`;
  }

  /*
    static getPasswordResetTokenPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/email/token/`
    }

    static getPasswordResetEmailPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/email/pass`
    }

    static getUsernameEmailPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/email/username`
    }

    static getPasswordResetPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/password`
    }

    static getUsernameResetPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/members/username`
    }
  */
  static getModifyAccountPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_MODIFY_ACCOUNT_PATH}`;
  }

  static getContactPreferencesPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_CONTACT_PREFERENCES_PATH}`
  }

  static getStatesPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_STATES_PATH}`;
  }


  static getLogPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_LOG_PATH}`;
  }

  /*
    static getMemApiAuthPath() {
      return `${window.REACT_APP_MEMBER_API_HOST}/v1/auth/tokensByPassword`;

    }
  */
  static getMembersPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_MEMBERS_PATH}`;
  }

  static getProductDescriptionPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_PRODUCT_DESCRIPTION_PATH}`;
  }

  /*
  static getLoginPath() {
    return '/v1/login'
  }
  */
  static getLogoutPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}/v1/logout`
  }

  static getJWTPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_CREDIT_JWT_PATH}`;
  }

  static getAlertSummaryPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERTS_SUMMARY_PATH}`;
  }

  static getNortonSOSPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_NORTON_SOS_PATH}`;
  }

  static getDigitalCleanerProvidersPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_DIGITAL_CLEANER_PROVIDERS_PATH}`;
  }

  static getAlertListInboxPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERTS_INBOX_PATH}`;
  }

  static getAlertListDarkWebPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERTS_DARK_WEB_INBOX_PATH}`;
  }

  static getAlertListDisputedPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERTS_DISPUTED_PATH}`;
  }

  static getAlertListArchivedPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERTS_ARCHIVED_PATH}`;
  }

  static getAlertDetailPath(alertId) {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_ALERT_DETAIL_PATH}/${alertId}`;
  }

  /*
  static getBillingInfoPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}/v1/billing/info`;
  }

  static getBillingMembersPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}/v1/billing/members`;
  }

  static getBillingHistoryPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}/v1/billing/history`;
  }
  */

  static getAddInstitutionLoginPath() {
    // for mock urls, create an alternate config.js and load that before running tests
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TXM_ADD_INST_LOGIN_PATH}`;
  }

  static getAnswerAddInstitutionLoginChallengePath() {
    // for mock urls, create an alternate config.js and load that before running tests
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TXM_ANS_INST_LOGIN_PATH}`;
  }

  static getUpdateInstitutionLoginPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TXM_UPDATE_INST_LOGIN_PATH}`;
  }

  static getAnswerUpdateInstitutionLoginChallengePath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TXM_ANS_UPDATE_INST_LOGIN_CHALLENGE_PATH}`;
  }

  static getRestorationCasesPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_RESTORATION_CASES_PATH}`;
  }

  static getLPMFulfillPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_PRIVACY_MONITOR_FULFILL_PATH}`;
  }

  static uploadRestorationDocumentPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_RESTORATION_UPLOAD_PATH}`;
  }

  static parentWindowResizeScroll() {
    return window.parent.postMessage({type: "RESIZED", payload: document.body.scrollHeight}, window.REACT_APP_PARENT_HOST);
  }

  static updateOnboardingFlag() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_UPDATE_ONBOARDING_FLAG_PATH}`;
  }

  static tokensByNslTokenPath() {
    return `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TOKENS_BY_NSL_TOKENS_PATH}`;
  }

  static dspMenuList() {
    const localizedStringBundle = stringBundle(getLangCode());
    const list = [
      {value: "/dashboard", name: localizedStringBundle.DASHBOARD.toUpperCase()},
      {value: "/alerts/inbox", name: localizedStringBundle.ALERTS.toUpperCase()},
      {value: "/credit", name: localizedStringBundle.CREDIT.toUpperCase()},
      {value: "/transactions", name: localizedStringBundle.TRANSACTIONS.toUpperCase()},
      {value: "/restoration", name: localizedStringBundle.RESTORATION.toUpperCase()},
      {value: "/monitoring", name: localizedStringBundle.MONITORED_INFORMATION.toUpperCase()}
    ];
    return list;
  }

}



// WEBPACK FOOTER //
// ./src/helpers/utils.js